/**
 * Logger utility
 * Strips console.log in production, keeps errors/warnings
 */
/**
 * Create a logger instance
 * @param isDev - Whether to enable debug/log output (typically false in production)
 */
export function createLogger(isDev = false) {
    return {
        log: isDev ? console.log.bind(console) : () => { },
        error: console.error.bind(console),
        warn: console.warn.bind(console),
        debug: isDev ? console.debug.bind(console) : () => { },
    };
}
/**
 * Default logger instance
 * Checks NODE_ENV or defaults to development mode
 */
export const logger = createLogger(typeof process !== 'undefined' ? process.env.NODE_ENV !== 'production' : true);
//# sourceMappingURL=logger.js.map